import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoginUrlService {
  private _loginUrl: string | null = null;

  set loginUrl(val: string) {
    this._loginUrl = val;
  }

  get loginUrl(): string {
    if (this._loginUrl == null) throw new Error('login url is not set');

    return this._loginUrl;
  }
}
